const DeliveryTypeEnum = {
    PAC: 'PAC',
    SEDEX: 'SEDEX',
    PACMINI: 'PACMINI',
    OWN_DELIVERY: 'OWN_DELIVERY',
    SEDEX_HOJE: 'SEDEX_HOJE',
    ULTRA: 'ULTRA'
};

export default Object.freeze({
    ...DeliveryTypeEnum,
});

export const DeliveryTypeTitleEnum = Object.freeze({
  [DeliveryTypeEnum.PAC]: "Econômico",
  [DeliveryTypeEnum.SEDEX]: "Expresso",
  [DeliveryTypeEnum.PACMINI]: "Super Econômico",
  [DeliveryTypeEnum.OWN_DELIVERY]: "Super Expresso",
  [DeliveryTypeEnum.SEDEX_HOJE]: "Entrega Hoje",
  [DeliveryTypeEnum.ULTRA]: "Ultra Expresso",
});
